import React from 'react';
import { Languages } from 'lucide-react';
import { LANGUAGES, useLanguage } from '../i18n';

/**
 * Two languages, so a single button that swaps to the other one — a dropdown
 * for a binary choice costs a click and teaches nothing. The label shows the
 * language you would switch *to*, which is what the user is looking for.
 */
const LanguageToggle = () => {
  const { language, setLanguage, t } = useLanguage();
  const next = LANGUAGES.find((code) => code !== language) || language;

  return (
    <button
      onClick={() => setLanguage(next)}
      className="btn-ghost h-10 px-3 flex items-center gap-2"
      data-testid="language-toggle"
      aria-label={t('language.switch')}
      title={t('language.switch')}
    >
      <Languages className="h-4 w-4" />
      <span className="text-sm font-medium uppercase">{next}</span>
    </button>
  );
};

export default LanguageToggle;
